import React from 'react';
import { fetchWrapper } from '../../APIManager';
const MessagesStateContext = /*#__PURE__*/React.createContext();
const MessagesDispatchContext = /*#__PURE__*/React.createContext();
const initialState = {};

/** REDUCER **/
function MessagesReducer(state, action) {
  switch (action.type) {
    default:
      {
        throw new Error('Unhandled action type caught');
      }
  }
}

/** PROVIDER **/
function MessagesProvider(_ref) {
  let {
    value,
    children
  } = _ref;
  const [state, dispatch] = React.useReducer(MessagesReducer, initialState);
  return /*#__PURE__*/React.createElement(MessagesStateContext.Provider, {
    value: state
  }, /*#__PURE__*/React.createElement(MessagesDispatchContext.Provider, {
    value: dispatch
  }, children));
}

/** STATE/DISPATCH HOOKS **/
function useMessagesState() {
  const context = React.useContext(MessagesStateContext);
  if (context === undefined) {
    throw new Error('useMessagesState must be used within a MessagesProvider');
  }
  return context;
}
function useMessagesDispatch() {
  const context = React.useContext(MessagesDispatchContext);
  if (context === undefined) {
    throw new Error('useMessagesDispatch must be used within a MessagesProvider');
  }
  return context;
}

/** API **/
const messagesAPI = {
  sendNewMessage: async function (url, apiKey, data) {
    try {
      const slug = '/posts';
      const response = await fetchWrapper(url, slug, apiKey, 'POST', data);
      if (!response) {
        throw new Error('Failed to send a message');
      }
      return response;
    } catch (err) {
      return {};
    }
  }
};
export { MessagesProvider, useMessagesState, useMessagesDispatch, messagesAPI };
//# sourceMappingURL=index.js.map